export const plannedModules = [
  {
    id: 'supply-chain',
    name: '供应链管理',
    tone: 'green',
    icon: 'package-search',
    detail: '后续管理供应商、采购进度与交付节点。',
  },
  {
    id: 'customer-radar',
    name: '获客雷达',
    tone: 'blue',
    icon: 'radar',
    detail: '后续汇总线索来源、意向信号与跟进优先级。',
  },
  {
    id: 'payment-assistant',
    name: '回款助手',
    tone: 'amber',
    icon: 'circle-dollar-sign',
    detail: '后续追踪账期、收款节点与异常提醒。',
  },
  {
    id: 'trade-coach',
    name: 'AI 外贸教练',
    tone: 'violet',
    icon: 'graduation-cap',
    detail: '后续提供外贸流程训练和业务复盘。',
  },
] as const;

export type PlannedModule = (typeof plannedModules)[number];
